export const setAgendamentos = (data, start, end, retornos) => ({
    type: 'SET_AGENDAMENTOS',
    payload: { data, start, end, retornos }
})

export const clearAgendamentos = (start, end) => ({
    type: 'CLEAR_AGENDAMENTOS',
    payload: { start, end }
})

export const removeAll = () =>({
    type:'REMOVE_ALL',
})